module.exports = __webpack_public_path__ + "ai-bot-outlinewp62d5f6ecb7bb4616b084c74617a6be84.png";